declare namespace $ {

	type $giper_baza_link_chip__link_giper_baza_app_stat_page_1 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['home_link'] >
		,
		ReturnType< $giper_baza_link_chip['link'] >
	>
	type $giper_baza_link_chip__arg_giper_baza_app_stat_page_2 = $mol_type_enforce<
		({ 
			'section': string,
		})  & ReturnType< $giper_baza_link_chip['arg'] >
		,
		ReturnType< $giper_baza_link_chip['arg'] >
	>
	type $mol_chip__title_giper_baza_app_stat_page_3 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['uptime'] >
		,
		ReturnType< $mol_chip['title'] >
	>
	type $mol_view__sub_giper_baza_app_stat_page_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_6 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['cpu_user'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_8 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['cpu_system'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_mark_cross__labels_giper_baza_app_stat_page_9 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['times'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_giper_baza_app_stat_page_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_giper_baza_app_stat_page_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_13 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['mem_free'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_15 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['mem_used'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_mark_cross__labels_giper_baza_app_stat_page_16 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['times'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_giper_baza_app_stat_page_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_giper_baza_app_stat_page_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_20 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['fs_free'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_22 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['fs_used'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_mark_cross__labels_giper_baza_app_stat_page_23 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['times'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_giper_baza_app_stat_page_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_giper_baza_app_stat_page_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_27 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['fs_reads'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_29 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['fs_writes'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_mark_cross__labels_giper_baza_app_stat_page_30 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['times'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_giper_baza_app_stat_page_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_giper_baza_app_stat_page_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_34 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['port_slaves'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_36 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['port_masters'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_mark_cross__labels_giper_baza_app_stat_page_37 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['times'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_giper_baza_app_stat_page_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_giper_baza_app_stat_page_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_41 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['land_alive'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_43 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['land_ghost'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_mark_cross__labels_giper_baza_app_stat_page_44 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['times'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_giper_baza_app_stat_page_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_giper_baza_app_stat_page_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_plot_line__title_giper_baza_app_stat_page_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_giper_baza_app_stat_page_48 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['errors'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_mark_cross__labels_giper_baza_app_stat_page_49 = $mol_type_enforce<
		ReturnType< $giper_baza_app_stat_page['times'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_giper_baza_app_stat_page_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_giper_baza_app_stat_page_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_gallery__items_giper_baza_app_stat_page_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_gallery['items'] >
	>
	export class $giper_baza_app_stat_page extends $mol_page {
		home_link( ): ReturnType< ReturnType< $giper_baza_app_stat_page['home'] >['link'] >
		title( ): ReturnType< ReturnType< $giper_baza_app_stat_page['home'] >['name'] >
		Land( ): $giper_baza_link_chip
		uptime( ): string
		Uptime( ): $mol_chip
		Main( ): $mol_view
		cpu_user( ): readonly(any)[]
		Cpu_user( ): $mol_plot_line
		cpu_system( ): readonly(any)[]
		Cpu_system( ): $mol_plot_line
		Cpu_ruler_sec( ): $mol_plot_ruler_vert
		times( ): readonly(any)[]
		Cpu_mark( ): $mol_plot_mark_cross
		Cpu( ): $mol_chart
		mem_free( ): readonly(any)[]
		Mem_free( ): $mol_plot_line
		mem_used( ): readonly(any)[]
		Mem_used( ): $mol_plot_line
		Mem_ruler( ): $mol_plot_ruler_vert
		Mem_mark( ): $mol_plot_mark_cross
		Mem( ): $mol_chart
		fs_free( ): readonly(any)[]
		Fs_free( ): $mol_plot_line
		fs_used( ): readonly(any)[]
		Fs_used( ): $mol_plot_line
		Fs_usage_ruler( ): $mol_plot_ruler_vert
		Fs_usage_mark( ): $mol_plot_mark_cross
		Fs_usage( ): $mol_chart
		fs_reads( ): readonly(any)[]
		Fs_reads( ): $mol_plot_line
		fs_writes( ): readonly(any)[]
		Fs_writes( ): $mol_plot_line
		Fs_acting_ruler( ): $mol_plot_ruler_vert
		Fs_acting_mark( ): $mol_plot_mark_cross
		Fs_acting( ): $mol_chart
		port_slaves( ): readonly(any)[]
		Port_slaves( ): $mol_plot_line
		port_masters( ): readonly(any)[]
		Port_masters( ): $mol_plot_line
		Port_ruler_pct( ): $mol_plot_ruler_vert
		Port_mark( ): $mol_plot_mark_cross
		Ports( ): $mol_chart
		land_alive( ): readonly(any)[]
		Land_alive( ): $mol_plot_line
		land_ghost( ): readonly(any)[]
		Land_ghost( ): $mol_plot_line
		Land_count_ruler( ): $mol_plot_ruler_vert
		Land_count_mark( ): $mol_plot_mark_cross
		Land_count( ): $mol_chart
		errors( ): readonly(any)[]
		Errors( ): $mol_plot_line
		Error_count_ruler( ): $mol_plot_ruler_vert
		Error_count_mark( ): $mol_plot_mark_cross
		Error_count( ): $mol_chart
		Charts( ): $mol_gallery
		home( ): $giper_baza_app_home
		head( ): readonly(any)[]
		body_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map